import { z } from 'zod';
/**
 * Address autocomplete (step 2). The API proxies Google Places server-side —
 * the browser never talks to Google and never sees a key. The sessionToken is
 * minted by the client per completed pick, because Google bills a suggest run
 * plus its concluding details call as one session when they share a token.
 */
export const AddressSuggestQuery = z.object({
    q: z.string().min(3).max(120),
    session: z.string().min(8).max(64).optional(),
});
export const AddressSuggestion = z.object({
    placeId: z.string(),
    main: z.string(),
    secondary: z.string(),
});
export const AddressSuggestResponse = z.object({
    suggestions: z.array(AddressSuggestion),
});
export const AddressPlaceQuery = z.object({
    id: z.string().min(4).max(512),
    session: z.string().min(8).max(64).optional(),
});
export const AddressPlaceResponse = z.object({
    address: z.string(),
    city: z.string(),
    state: z.string(),
});
//# sourceMappingURL=places.js.map